import { Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect } from "react";
import Download from "../components/Download";
import ErrorMessage from "../components/ErrorMessage";
import ErrorTitle from "../components/ErrorTitle";
import { formLabel } from "../utils/formFieldLabels";

const CivilIdDocument = ({
  formData,
  handleChange,
  showError,
  errors,
  documentError,
  documentErrorMsg
}) => {
  useEffect(() => {
    document.title = "AUMS • Document";
  }, []);
  return (
    <Box sx={{}}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          backgroundColor: "#b60041",
          padding: "1rem",
          fontWeight: "bold"
        }}
      >
        <h4 className="form">Required Documents { " / المستندات المطلوبة " }</h4>
      </Box>

      <Box sx={{ padding: "0.5rem", color: "#606060" }}>
        <Box>
          <h4 className="my-3 font-bold text-center">
            {formLabel.document.title.english}      
          </h4>
          <div className="px-4">{showError && <ErrorTitle />}</div>
          <div className="px-4">
            {documentError && <ErrorMessage errorMessage={documentErrorMsg} />}
          </div>
        </Box>

        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead className="w-full ">
              {/* 1. Official grade transcript */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Copy of Official grade transcript or certified copy - Original High school certificate
                  {errors.transcript && (
                    <ErrorMessage errorMessage={errors.transcript} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <Download
                    formData={formData}
                    handleChange={handleChange}
                    value={"transcript"}
                  />
                </TableCell>
              </TableRow>
              {/* 2. Equivalency of high school degree */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Equivalency of high school degree issued by the Ministry of Education in Kuwait (for private school graduates)
                  {errors.highschool && (
                    <ErrorMessage errorMessage={errors.highschool} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <Download
                    formData={formData}
                    handleChange={handleChange}
                    value={"highschool"}
                  />
                </TableCell>
              </TableRow>
              {/* 3. IELTS/TOEFL */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Valid IELTS/TOEFL score report (if available) (no older than two years)
                  {errors.englishscore && (
                    <ErrorMessage errorMessage={errors.englishscore} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <Download
                    formData={formData}
                    handleChange={handleChange}
                    value={"englishscore"}
                  />
                </TableCell>
              </TableRow>
              {/* 4. Birth certificate */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Copy of birth certificate
                  {errors.record && (
                    <ErrorMessage errorMessage={errors.record} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <Download
                    formData={formData}
                    handleChange={handleChange}
                    value={"record"}
                  />
                </TableCell>
              </TableRow>
              {/* 5. Civil ID and Passport */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Valid National Civil ID (no less than 3 months validity) and valid passport photocopies
                  <br />
                  1. Civil ID FRONT COPY
                  {errors.civilidFront && (
                    <ErrorMessage errorMessage={errors.civilidFront} />
                  )}
                  {!errors.civilidFront && <br />}
                  2. Civil ID BACK COPY
                  <br />
                  {errors.civilidBack && (
                    <ErrorMessage errorMessage={errors.civilidBack} />
                  )}
                  <br />
                  3. Passport Copy
                  {errors.passport && (
                    <ErrorMessage errorMessage={errors.passport} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <div style={{
                    display: "flex",
                    gap: "0.3rem",
                    width: "100%",
                    flexDirection: "column",
                    justifyContent: "flex-end"
                  }}>
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"civilidFront"}
                    />
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"civilidBack"}
                    />
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"passport"}
                    />
                  </div>
                </TableCell>
              </TableRow>
              {/* 6. Security cards (for non-Kuwaitis) */}
              {formData.nationality.value === "Non Kuwaiti" && (
                <TableRow>
                  <TableCell sx={{ fontWeight: "700" }} align="left">
                    Valid Security cards (for non-Kuwaitis)
                    <br />
                    1. FRONT COPY
                    {errors.securityCardFront && (
                      <ErrorMessage errorMessage={errors.securityCardFront} />
                    )}
                    {!errors.securityCardFront && <br />}
                    2. BACK COPY
                    <br />
                    {errors.securityCardBack && (
                      <ErrorMessage errorMessage={errors.securityCardBack} />
                    )}
                  </TableCell>
                  <TableCell className="w-[300px]">
                    <div style={{
                      display: "flex",
                      gap: "0.3rem",
                      width: "100%",
                      flexDirection: "column",
                      justifyContent: "flex-end"
                    }}>
                      <Download
                        formData={formData}
                        handleChange={handleChange}
                        value={"securityCardFront"}
                      />
                      <Download
                        formData={formData}
                        handleChange={handleChange}
                        value={"securityCardBack"}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              )}

              {/* 6b. Sahel App (for Kuwaitis) */}
              {formData.nationality.value === "Kuwait" && (
                <TableRow>
                  <TableCell sx={{ fontWeight: "700" }} align="left">
                    Kuwaiti Applicants: Sahel App (Certificate proof of citizenship of father)
                    {errors.sahel && (
                      <ErrorMessage errorMessage={errors.sahel} />
                    )}
                  </TableCell>
                  <TableCell className="w-[300px]">
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"sahel"}
                    />
                  </TableCell>
                </TableRow>
              )}
              {/* 7. Good Conduct Certificate */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Good Conduct Certificate
                  {errors.goodconduct && (
                    <ErrorMessage errorMessage={errors.goodconduct} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <Download
                    formData={formData}
                    handleChange={handleChange}
                    value={"goodconduct"}
                  />
                </TableCell>
              </TableRow>
              {/* 8. Parents/Guardian Civil ID */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Parent/Guardian Civil ID
                  <br />
                  1. Father Civil ID
                  {errors.fatherCivilId && (
                    <ErrorMessage errorMessage={errors.fatherCivilId} />
                  )}
                  <br />
                  2. Mother Civil ID
                  {errors.motherCivilId && (
                    <ErrorMessage errorMessage={errors.motherCivilId} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <div style={{
                    display: "flex",
                    gap: "0.3rem",
                    width: "100%",
                    flexDirection: "column",
                    justifyContent: "flex-end"
                  }}>
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"fatherCivilId"}
                    />
                    <Download
                      formData={formData}
                      handleChange={handleChange}
                      value={"motherCivilId"}
                    />
                  </div>
                </TableCell>
              </TableRow>
              {/* 9. Personal photo */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Personal recent photo 4*6
                  {errors.photograph && (
                    <ErrorMessage errorMessage={errors.photograph} />
                  )}
                </TableCell>
                <TableCell className="w-[300px]">
                  <Download
                    formData={formData}
                    handleChange={handleChange}
                    value={"photograph"}
                  />
                </TableCell>
              </TableRow>
              {/* 10. Additional documents note */}
              <TableRow>
                <TableCell sx={{ fontWeight: "700" }} align="left">
                  Additional documents may be required from admission office in the College of Pharmacy.
                </TableCell>
                <TableCell className="w-[300px]"></TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default CivilIdDocument;
